import safeFetch from '../../shared/api/safeFetch';

export function updateChatMessages({ previousMessages, newMessages, loadMore }) {
  // change the order of chat messages starting with the oldest
  const freshPayloadMessages = [...newMessages].reverse();
  if (!loadMore) {
    return freshPayloadMessages;
  }
  const firstMessageId = previousMessages[0]?.id || 0;
  return firstMessageId > freshPayloadMessages[0].id
    ? [...freshPayloadMessages.filter((message) => message.id < firstMessageId), ...previousMessages]
    : previousMessages;
}

export function updateUploadedData({ isClear, fileId, uploadedFilesData }) {
  /* Handle files, attached to message. Message not send yet */
  let updatedData = [];
  if (!isClear) {
    const index = uploadedFilesData.findIndex((file) => file.id === fileId);
    updatedData = uploadedFilesData.slice();
    updatedData.splice(index, 1);
  }
  return updatedData;
}

export function deleteDialog({ chats, dialog }) {
  return chats.filter((chat) => chat.id !== dialog);
}

export function removeDuplicates({ chats, dialogs, isAppend }) {
  const merged = isAppend ? chats.concat(dialogs) : dialogs;
  const existingIds = new Set();
  const result = [];

  merged.forEach((dialog) => {
    if (!existingIds.has(dialog.id)) {
      existingIds.add(dialog.id);
      result.push(dialog);
    }
  });

  return result;
}
export function getMobileState({ state, updatedChats }) {
  return {
    ...state,
    chats: updatedChats,
    isChatOpen: false,
    selectedChatId: null,
    selectedDialogInfo: null,
  };
}
export function getDesktopState({ state, updatedChats }) {
  return {
    ...state,
    chats: updatedChats,
    isChatOpen: updatedChats.length,
    selectedChatId: updatedChats.length ? updatedChats[0].id : null,
    selectedDialogInfo: null,
  };
}

export function getMessages(path) {
  const params = { headers: { access: '*/*' }, method: 'GET' };
  return safeFetch(path, params);
}

export function generatePathToGetMessages({
  chatInfo,
  loadMore,
  selectedChatId,
  stateSelectedChatId,
  limitMessages = 20,
}) {
  const lastMessageId = loadMore && chatInfo.length > 19 ? chatInfo[0]?.id : null;
  const chatId = loadMore ? stateSelectedChatId : selectedChatId;
  const baseDialogUrl = `/api/chat/v1/dialogs/${chatId}?limit=${limitMessages}`;
  return lastMessageId ? `${baseDialogUrl}&lastMessageId=${lastMessageId}` : baseDialogUrl;
}

export function parseFolderDialogs(dialogs) {
  return dialogs.map((dialog) => ({
    id: dialog.id,
    image: dialog.image,
    name: dialog?.fullName || dialog?.name,
    nickname: dialog.nickname,
    type: dialog.cType,
  }));
}

export const parseFoundChats = (data) =>
  data.map((dialog) => {
    return {
      folderNames: dialog?.folderNames || [],
      id: dialog.dialogId,
      image: dialog?.image,
      name: dialog?.fullName || dialog?.name,
      status: dialog?.status,
      type: dialog.dialogType,
    };
  });

export function insertAtSecondLast(arr, element) {
  arr.splice(arr.length - 1, 0, element);
  return arr;
}
